export default __webpack_public_path__ + "static/media/40.d9bc9a00.jpeg";